<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>
    {{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }} Form
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">

    <div class="d-flex justify-content-between flex-column flex-lg-row pt-0 pb-4">
      <div>
        <button
          mat-raised-button
          color="secondary"
          class="my-2 ml-0 mr-1"
          (click)="onSelectReportedBy()"
          [matBadge]="toolbox_talk.reported_by ? '1' : '0'"
          matTooltip="You can optionally select a reviewer."
          type="button">
          <mat-icon>rate_review</mat-icon>
          {{ !toolbox_talk.reported_by ? 'Assign' : 'Change' }} Conducted By User
        </button>
      </div>

      <div *ngIf="toolbox_talk.id"
        [matTooltip]="'You can copy this ' + utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') + ' to other ' + utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() + '.'">
        <mat-checkbox [(ngModel)]="toolbox_talk.copy_to_all_sites" name="copy_to_all_sites" class="my-2 ml-1 mr-2">
          Copy to all {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }} or
        </mat-checkbox>
        <button
          mat-raised-button
          type="button"
          color="secondary"
          (click)="onSelectSites()"
          class="my-2 ml-1 mr-0"
          [matBadge]="toolbox_talk.copy_to_all_sites ? 'All' : toolbox_talk.selected_site_ids?.length.toString()"
          matBadgePosition="below before">
          <mat-icon>file_copy</mat-icon>
          Copy to Selected {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
        </button>
      </div>
    </div>

    <mat-form-field class="mb-3" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }}</mat-label>
      <input
        matInput
        [placeholder]="utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk')"
        [(ngModel)]="toolbox_talk.name"
        name="name"
        type="text"
        #name
        required />
      <mat-error *ngIf="!name.valid">
        Please enter the name or subject of the {{ utils.getLangTerm('toolbox-talks.singular', 'Toolbox Talk') }}.
      </mat-error>
    </mat-form-field>

    <app-rich-text-editor
      style="margin: 0.6rem 0 1.6rem;"
      placeholder="Induction"
      [(ngModel)]="toolbox_talk.agenda"
      name="toolbox_talks_agenda"
      [height]="350">
    </app-rich-text-editor>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id && toolbox_talk.site">
      <mat-label>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name</mat-label>
      <input
        matInput
        placeholder="{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Name"
        [value]="toolbox_talk.site?.name"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id && toolbox_talk.site">
      <mat-label>{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Address</mat-label>
      <input
        matInput
        placeholder="{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Address"
        [value]="toolbox_talk.site?.location"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id && toolbox_talk.users.length">
      <mat-label>Attendees</mat-label>
      <input
        matInput
        [value]="formatUsers(toolbox_talk.users)"
        placeholder="Attendees"
        name="attendees"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id && toolbox_talk.creator">
      <mat-label>Created By</mat-label>
      <input
        matInput
        placeholder="Created By"
        [value]="toolbox_talk.creator?.contact_person"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id">
      <mat-label>Created At</mat-label>
      <input
        matInput
        placeholder="Created At"
        [value]="(toolbox_talk.date_created * 1000) | timezoneConvertLong"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id && toolbox_talk.updater">
      <mat-label>Last Updated By</mat-label>
      <input
        matInput
        placeholder="Last Updated By"
        [value]="toolbox_talk.updater?.contact_person"
        type="text"
        disabled />
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="toolbox_talk.id">
      <mat-label>Last Updated At</mat-label>
      <input
        matInput
        placeholder="Last Updated At"
        [value]="(toolbox_talk.date_modified * 1000) | timezoneConvertMedium"
        type="text"
        disabled />
    </mat-form-field>
  </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    mat-raised-button
    *ngIf="!toolbox_talk.id"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save & Close
  </button>

  <button
    mat-raised-button
    *ngIf="toolbox_talk.id"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <button
    mat-raised-button
    *ngIf="toolbox_talk.id"
    [disabled]="!f.valid || inProgress"
    color="primary"
    (click)="onSubmit(f, true)"
    class="my-2 ml-1 mr-2"
    type="button">
    <mat-icon>save</mat-icon>
    Save & Continue
  </button>

  <app-file-browse-button
    (selectedFiles)="onSelectFiles($event)"
    (afterDialogClosedEvent)="onSubmit(f, false)"
    parentObjectType="toolbox-talks"
    [parentObjectId]="toolbox_talk?.id"
    [filesCount]="toolbox_talk?.files?.length">
  </app-file-browse-button>

  <button
    mat-raised-button
    (click)="onSelectUsers()"
    color="secondary"
    class="my-2 ml-1 mr-2"
    [matBadge]="toolbox_talk?.user_ids.length.toString()"
    type="button">
    <mat-icon>people</mat-icon>
    Attendees
  </button>

  <button
    mat-raised-button
    (click)="onExport('pdf')"
    color="secondary"
    class="my-2 ml-1 mr-2"
    type="button"
    *ngIf="toolbox_talk.id && toolbox_talk.site_id">
    <mat-icon>cloud_download</mat-icon>
    Export PDF
  </button>

  <button
    mat-raised-button
    (click)="onExport('csv')"
    color="secondary"
    class="my-2 ml-1 mr-2"
    type="button"
    *ngIf="toolbox_talk.id && toolbox_talk.site_id">
    <mat-icon>cloud_download</mat-icon>
    Export CSV
  </button>

  <button
    mat-raised-button
    color="secondary"
    type="button"
    class="my-2 ml-1 mr-2"
    (click)="onSelectSnippets()"
    *ngIf="!(toolbox_talk.id && toolbox_talk.site_id)">
    <mat-icon>add</mat-icon>
    Add Snippet
  </button>

  <ng-container *ngIf="toolbox_talk.id && toolbox_talk.site_id">
    <div class="w-100"></div>
    <button
      mat-raised-button
      color="secondary"
      type="button"
      class="my-2 ml-1 mr-2"
      (click)="onSelectSnippets()">
      <mat-icon>add</mat-icon>
      Add Snippet
    </button>
  </ng-container>
</mat-dialog-actions>
